import React from 'react'
import Button from '../../../shared/Button'
import PersianNumber from '../../../shared/PersianNumber'

const MyCounterStatics = ({dahsboardInfo}) => {
    //Danafont
  return (
    <div className='MyCounterStatics'>
        <div className='MyCounterStatics--box'>
            <h4 className='flex gap-[2px]'>
            <div className='Danafont '><PersianNumber number={dahsboardInfo.current_reserves_count} /></div> <div>
            اقامتگاه
            </div>
            </h4>
            <p>ثبت شده از اقامتگاه های شما</p>
            <Button varient="borderbot">
            افزودن اقامتگاه
            </Button>
        </div>
        <div className='MyCounterStatics--box'>
            <h4 className='flex gap-[2px]'>
            <div className='Danafont'><PersianNumber number={dahsboardInfo.user_balance_wallet} /></div> ریال
            </h4>
            <p>موجودی حساب شما</p>
            <Button varient="borderbot">
            افزایش موجودی
            </Button>
        </div>
        <div className='MyCounterStatics--box'>
            <h4 className='flex gap-[2px]'>
            <div className='Danafont'><PersianNumber number={dahsboardInfo.notifications_count} /></div> اطلاعیه
            </h4>
            <p>جاری از 12 اطلاعیه کل</p>
            <Button varient="borderbot">
            برسی اطلاعیه ها
            </Button>
        </div>
        <div className='MyCounterStatics--box'>
            <h4 className='flex gap-[2px]'>
            <div className='Danafont'><PersianNumber number={dahsboardInfo.current_reserves_count} /></div> رزرو جاری
            </h4 >
            <p>از مجموع 24 سفر های شما</p>
            <Button varient="borderbot">
            سفر جدید
            </Button>
        </div>
    </div>
  )
}

export default MyCounterStatics